import PropTypes from "prop-types";
import { useFormState } from "react-hook-form";
const ApexSuccess = ({
  children
}) => {
  const formStateProxy = useFormState();
  const formState = {
    isSubmitSuccessful: formStateProxy.isSubmitSuccessful
  };
  return formState.isSubmitSuccessful && children;
};
ApexSuccess.propTypes = {
  children: PropTypes.node.isRequired
};
ApexSuccess.defaultProps = {};
export {
  ApexSuccess as default
};
